module.exports = __webpack_public_path__ + "static/media/Moldflow Insight.7fbfc988.png";